import { ReactComponent as Onboarding } from "../assets/Grapic_Bg.svg";

export function WelcomeSection() {
  return (
    <section
      className="w-1/2 flex flex-col bg-primary-80 min-h-screen   
      md:py-8 md:px-10
      sm:py-10 sm:px-4 sm:min-h-[300px]
      justify-between relative"
    >
      <Onboarding className="absolute inset-0 w-full h-full object-cover z-0" />
      {/* Logo/Header */}
      <div className="flex items-center gap-4 mb-12 sm:mb-8 relative z-10">
        <div className="flex items-center justify-center rounded-full border border-gray-300 bg-zinc-100 h-10 w-10 sm:h-8 sm:w-8">
          <span className="text-lg text-stone-500 font-bold" style={{ fontFamily: "Alkalami" }}>
            Z
          </span>
        </div>
        <span className="text-2xl font-semibold text-white sm:text-xl">Zinancial</span>
      </div>

      {/* Main Content */}
      <div className="flex flex-col gap-8 items-start flex-1 justify-center px-16 relative z-10 font-Inter">
        <div className="flex flex-col gap-6 items-start">
          <h1 className="text-5xl font-bold tracking-wider text-white md:text-5xl sm:text-3xl leading-5">
            Welcome to{" "}
            <div className="pt-1 text-5xl font-bold tracking-wider text-white md:text-5xl sm:text-3xl leading-5">
              Zinancial{" "}
            </div>{" "}
          </h1>
          <p className="text-base leading-7 text-white md:text-lg md:leading-6 sm:text-sm sm:leading-5">
            Manage daily bookkeeping and ledgers effortlessly. Generate automated, <br /> real-time financial reports.
          </p>
        </div>
      </div>
    </section>
  );
}
